import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { lazyContextAddon10t74vogc7n59 as lazyContextAddon } from './views/ViewContextExtensions.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  split2bvyvnrlcifjv as split,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_externalServices(_this__u8e3s4) {
  _init_properties_ExternalServices_kt__szl2ax();
  var tmp = KProperty1();
  return externalServices$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('externalServices', 1, tmp, _get_externalServices_$ref_m7ud0v(), null));
}
var externalServices$delegate;
function downloadBlob(name, blob, preferredDestination, $completion, $super) {
  preferredDestination = preferredDestination === VOID ? DownloadLocation_Downloads_getInstance() : preferredDestination;
  return $super === VOID ? this.download_fe598d_k$(name, blob, preferredDestination, $completion) : $super.download_fe598d_k$.call(this, name, blob, preferredDestination, $completion);
}
var FileDownloadAccessClass;
function FileDownloadAccess() {
  if (FileDownloadAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FileDownloadAccess', VOID, VOID, VOID, [3, 4]);
    FileDownloadAccessClass = $;
  }
  return FileDownloadAccessClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  DownloadLocation_Downloads_instance = new (DownloadLocation())('Downloads', 0);
  DownloadLocation_Pictures_instance = new (DownloadLocation())('Pictures', 1);
}
var DownloadLocation_Downloads_instance;
var DownloadLocation_Pictures_instance;
var DownloadLocationClass;
function DownloadLocation() {
  if (DownloadLocationClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'DownloadLocation');
    DownloadLocationClass = $;
  }
  return DownloadLocationClass;
}
function setClipboardText(_this__u8e3s4, value) {
  _init_properties_ExternalServices_kt__szl2ax();
  return get_externalServices(_this__u8e3s4).setClipboardText_63qwyx_k$(value);
}
function *download(_this__u8e3s4, name, blob, preferredDestination, $completion) {
  preferredDestination = preferredDestination === VOID ? DownloadLocation_Downloads_getInstance() : preferredDestination;
  return yield* get_externalServices(_this__u8e3s4).download_fe598d_k$(name, blob, preferredDestination, $completion);
}
function *requestFile(_this__u8e3s4, mimeTypes, $completion) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  return yield* get_externalServices(_this__u8e3s4).requestFile_cpkodl_k$(mimeTypes, $completion);
}
function _get_ctx__e66oga($this) {
  return $this.get_baseContext_3c5z9n_k$();
}
var ExternalServicesClass;
function ExternalServices() {
  if (ExternalServicesClass === VOID) {
    class $ {
      get_baseContext_3c5z9n_k$() {
        var tmp = this.baseContext_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('baseContext');
        }
      }
      *download_fe598d_k$(name, blob, preferredDestination, $completion) {
        return yield* /*#__NOINLINE__*/download(_get_ctx__e66oga(this), name, blob, preferredDestination, $completion);
      }
      downloadBlob(name, blob, preferredDestination, $completion, $super) {
        preferredDestination = preferredDestination === VOID ? DownloadLocation_Downloads_getInstance() : preferredDestination;
        return $super === VOID ? this.download_fe598d_k$(name, blob, preferredDestination, $completion) : $super.download_fe598d_k$.call(this, name, blob, preferredDestination, $completion);
      }
      *shareBlob(namesToBlobs, $completion) {
        return yield* share(_get_ctx__e66oga(this), namesToBlobs, $completion);
      }
    }
    initMetadataForObject($, 'ExternalServices', VOID, VOID, VOID, [1, 3, 4]);
    ExternalServicesClass = $;
  }
  return ExternalServicesClass;
}
var ExternalServices_instance;
function ExternalServices_getInstance() {
  return ExternalServices_instance;
}
function *share(_this__u8e3s4, namesToBlobs, $completion) {
  return yield* get_externalServices(_this__u8e3s4).shareBlob(namesToBlobs, $completion);
}
function externalServices$delegate$lambda(it) {
  _init_properties_ExternalServices_kt__szl2ax();
  return externalServicesAccessDefault(it);
}
function _get_externalServices_$ref_m7ud0v() {
  return constructCallableReference((p0) => get_externalServices(p0), 1, 0, 94);
}
function DownloadLocation_Downloads_getInstance() {
  static_init();
  return DownloadLocation_Downloads_instance;
}
var properties_initialized_ExternalServices_kt_uo8ror;
function _init_properties_ExternalServices_kt__szl2ax() {
  if (!properties_initialized_ExternalServices_kt_uo8ror) {
    properties_initialized_ExternalServices_kt_uo8ror = true;
    externalServices$delegate = lazyContextAddon(externalServices$delegate$lambda);
  }
}
function get_validDownloadName() {
  _init_properties_ExternalServices_kt__szl2ax_0();
  return validDownloadName;
}
var validDownloadName;
function set_lastFileInput(_set____db54di) {
  _init_properties_ExternalServices_kt__szl2ax_0();
  lastFileInput = _set____db54di;
}
function get_lastFileInput() {
  _init_properties_ExternalServices_kt__szl2ax_0();
  return lastFileInput;
}
var lastFileInput;
function externalServicesAccessDefault(context) {
  _init_properties_ExternalServices_kt__szl2ax_0();
  return new (JsExternalServices())(context);
}
function JsExternalServices$requestFile$lambda($this$requestFileInput) {
  return Unit_instance;
}
var JsExternalServicesClass;
function JsExternalServices() {
  if (JsExternalServicesClass === VOID) {
    class $ {
      constructor(ctx) {
        this.ctx_1 = ctx;
      }
      *requestFile_cpkodl_k$(mimeTypes, $completion) {
        return firstOrNull(yield* requestFileInput(this.ctx_1, mimeTypes, JsExternalServices$requestFile$lambda, $completion));
      }
      setClipboardText_63qwyx_k$(value) {
        window.navigator.clipboard.writeText(value);
      }
      *download_fe598d_k$(name, blob, preferredDestination, $completion) {
        // Inline function 'kotlin.text.matches' call
        if (!get_validDownloadName().matches_evli6i_k$(name))
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Name ' + name + ' has invalid characters!');
        var tmp = document.createElement('a');
        var a = tmp instanceof HTMLAnchorElement ? tmp : THROW_CCE();
        var url = URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        a.target = '_blank';
        a.click();
        // Inline function 'com.lightningkite.kiteui.afterTimeout' call
        var tmp_0 = window;
        var handle = tmp_0.setTimeout(() => {
          URL.revokeObjectURL(url);
          return Unit_instance;
        }, convertToInt(60000n));
        return Unit_instance;
      }
      downloadBlob(name, blob, preferredDestination, $completion, $super) {
        return this.downloadBlob(name, blob, preferredDestination, $completion, ($super == null ? true : $super instanceof JsExternalServices()) ? $super : THROW_CCE());
      }
      *shareBlob_7gx7ic_k$(namesToBlobs, $completion) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(namesToBlobs, 10));
        var _iterator__ex2g4s = namesToBlobs.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var name = item.first_1;
          var blob = item.second_1;
          var tmp0_elvis_lhs = lastOrNull(split(blob.type, ['/']));
          var type = tmp0_elvis_lhs == null ? 'png' : tmp0_elvis_lhs;
          var fileName = contains(name, '.') ? name : name + '.' + type;
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = [blob];
          var tmp1 = blob.type;
          // Inline function 'org.w3c.files.FilePropertyBag' call
          var lastModified = undefined;
          var o = {};
          o['lastModified'] = lastModified;
          o['type'] = tmp1;
          var tmp$ret$2 = new File(tmp, fileName, o);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var files = destination;
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$7 = copyToArray(files);
        var data = json([to('files', tmp$ret$7)]);
        // Inline function 'kotlin.js.asDynamic' call
        if (window.navigator.canShare()) {
          // Inline function 'kotlin.js.asDynamic' call
          window.navigator.share(data);
        } else {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Your browser won't let you share these files.");
        }
        return Unit_instance;
      }
      shareBlob(namesToBlobs, $completion) {
        return this.shareBlob_7gx7ic_k$(namesToBlobs, $completion);
      }
    }
    protoOf($).downloadBlob = downloadBlob;
    initMetadataForClass($, 'JsExternalServices', VOID, VOID, [FileDownloadAccess()], [1, 4, 3, 0]);
    JsExternalServicesClass = $;
  }
  return JsExternalServicesClass;
}
function *requestFileInput(_this__u8e3s4, mimeTypes, setup, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    var it = cancellable;
    removeFileInput();
    var tmp = document.createElement('input');
    // Inline function 'kotlin.apply' call
    var this_0 = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    var $this$apply = this_0;
    $this$apply.type = 'file';
    $this$apply.hidden = true;
    $this$apply.accept = joinToString(mimeTypes, ',');
    setup($this$apply);
    $this$apply.addEventListener('change', (_unused_var__etf5q3) => {
      var tmp0 = it;
      var tmp0_safe_receiver = $this$apply.files;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = until(0, tmp0_safe_receiver.length);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.first_1;
        var last = this_0.last_1;
        if (inductionVariable <= last)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var index = item;
            var tmp$ret$10 = ensureNotNull(tmp0_safe_receiver.item(index));
            destination.add_utx5q5_k$(tmp$ret$10);
          }
           while (!(item === last));
        tmp = destination;
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.collections.listOf' call
        tmp_0 = emptyList();
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = tmp_0;
      var tmp$ret$13 = _Result___init__impl__xyqfz8(value);
      tmp0.resumeWith_rk9gbt_k$(tmp$ret$13);
      removeFileInput();
      return Unit_instance;
    });
    $this$apply.addEventListener('cancel', (_unused_var__etf5q3) => {
      var tmp0 = it;
      // Inline function 'kotlin.collections.listOf' call
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = emptyList();
      var tmp$ret$16 = _Result___init__impl__xyqfz8(value);
      tmp0.resumeWith_rk9gbt_k$(tmp$ret$16);
      removeFileInput();
      return Unit_instance;
    });
    ensureNotNull(document.body).appendChild($this$apply);
    set_lastFileInput($this$apply);
    this_0.click();
    return cancellable.getResult_fck196_k$();
  };
}
function removeFileInput() {
  _init_properties_ExternalServices_kt__szl2ax_0();
  var tmp0_safe_receiver = get_lastFileInput();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    ensureNotNull(document.body).removeChild(tmp0_safe_receiver);
  }
  set_lastFileInput(null);
}
var properties_initialized_ExternalServices_kt_uo8ror_0;
function _init_properties_ExternalServices_kt__szl2ax_0() {
  if (!properties_initialized_ExternalServices_kt_uo8ror_0) {
    properties_initialized_ExternalServices_kt_uo8ror_0 = true;
    validDownloadName = Regex().new_kotlin_text_Regex_acuq4a_k$('[a-zA-Z0-9.\\-_]+');
    lastFileInput = null;
  }
}
//region block: init
ExternalServices_instance = new (ExternalServices())();
//endregion
//region block: exports
export {
  setClipboardText as setClipboardTextsmriix4g698x,
  ExternalServices_instance as ExternalServices_instance8vpkk4rsrb5w,
  download as download3e9i5zj8k9dp8,
  requestFile as requestFile23u83st3mccw5,
};
//endregion

//# sourceMappingURL=ExternalServices.mjs.map
